<mat-expansion-panel class="box-shadow border-radius-0" (opened)="onExpanded()">
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4 panel-title-icon">people</mat-icon>
      <span>Crew</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div *ngIf="{
      crew: crew$ | async ,
      crewLocation: crewLocation$ | async
    } as vm">
      <div *ngIf="vm.crew?.response as crewList">
        <app-data-box headerTitle="Pilots" class="mt-24">
          <div class="crew-container">
            <app-crew-table [crewList]="crewList?.pilots" crewType="pilot"
              [showSeqNumbers]="showSeqNumbers$ | async"></app-crew-table>
          </div>
        </app-data-box>

        <app-data-box headerTitle="Flight Attendants" class="mt-32">
          <div class="crew-container">
            <app-crew-table [crewList]="crewList?.flightAttendants" crewType="fa"
              [crewLocation]="vm.crewLocation?.response" [showSeqNumbers]="showSeqNumbers$ | async"></app-crew-table>
          </div>
        </app-data-box>

        <div *ngIf="crewList?.deadhead && (crewList?.deadhead)!.length > 0">
          <app-data-box headerTitle="Deadheading" crewType="dh" class="mt-32">
            <div class="crew-container">
              <app-crew-table [crewList]="crewList?.deadhead"
                [showSeqNumbers]="showSeqNumbers$ | async"></app-crew-table>
            </div>
          </app-data-box>
        </div>

        <div *ngIf="
            crewList?.deadheadTraining &&
            (crewList?.deadheadTraining)!.length > 0
          ">
          <app-data-box headerTitle="Training Deadheads" class="mt-32">
            <div class="crew-container">
              <app-crew-table [crewList]="crewList?.deadheadTraining" crewType="dh"
                [showSeqNumbers]="showSeqNumbers$ | async"></app-crew-table>
            </div>
          </app-data-box>
        </div>

        <div *ngIf="vm.crew" class="options-container thin-gray-border flex-around">
          <mat-slide-toggle (change)="onSeqNumToggleChanged($event)" [checked]="showSeqNumbers$ | async" color="accent"
            class="width-100 text-center">
            <span class="label-3">Sequences</span>
          </mat-slide-toggle>
          <div matRipple class="text-button left-divider-1 width-100 text-center" (click)="onViewNsClick()">
            NS
          </div>
        </div>
      </div>
      <div *ngIf="vm.crew?.isLoading && !vm.crew?.response" class="loading-container">
        <mat-spinner color="accent" [diameter]="32"></mat-spinner>
      </div>

      <div *ngIf="vm.crew?.isCompleteWithNoResponse()">
        <div class="text-sm text-center">Crew list unavailable</div>
      </div>

      <div class="data-status">
        <app-data-status [isLoading]="vm.crew?.isLoading" [timestamp]="vm.crew?.response?.timestamp"
          (refresh)="refreshCrew()"></app-data-status>
      </div>
      <mat-progress-bar *ngIf="vm.crew?.isLoading" class="progress-bar-bottom" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>